// src/pages/About/scenes/DialogBubble.jsx
import { motion as Motion } from "framer-motion";
import cls from "../About.module.scss";
import mrPng from "@/assets/NEW/MrMrs/MrNoty.webp";
import mrsPng from "@/assets/NEW/MrMrs/MrsNoty.webp";

export default function DialogBubble({ speaker = "mr", text }) {
  const isMr = speaker === "mr";
  const variants = {
    hidden: { opacity: 0, x: isMr ? -24 : 24 },
    show: { opacity: 1, x: 0 },
  };

  return (
    <Motion.section
      className={`${cls.bubble} ${
        isMr ? cls["bubble--mr"] : cls["bubble--mrs"]
      }`}
      role="group"
      aria-label={isMr ? "Mr Noty says" : "Mrs Noty says"}
      variants={variants}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-20% 0px -20% 0px" }}
      transition={{ duration: 0.24, ease: "easeOut" }}
    >
      <img
        src={isMr ? mrPng : mrsPng}
        alt={isMr ? "Mr Noty" : "Mrs Noty"}
        className={cls.avatar}
        loading="lazy"
      />
      <p className={cls.text}>{text}</p>
    </Motion.section>
  );
}
